import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Services.css';

const Services = () => {
  const servicesData = [
    {
      icon: '🧹',
      title: 'Limpieza',
      description: 'Servicios integrales de limpieza corporativa, hospitalaria, industrial y educativa con productos ecológicos certificados.',
      link: '/servicios/limpieza'
    },
    {
      icon: '👥',
      title: 'Servicios Auxiliares',
      description: 'Personal especializado para recepción, seguridad, logística y servicios de apoyo operacional.',
      link: '/servicios/auxiliares'
    },
    {
      icon: '🔧',
      title: 'Mantenimiento e Ingeniería',
      description: 'Soluciones de mantenimiento preventivo y correctivo para instalaciones industriales y corporativas.',
      link: '/servicios/mantenimiento'
    },
    {
      icon: '💼',
      title: 'Recursos Humanos',
      description: 'Gestión integral de personal: reclutamiento, selección, capacitación y administración de RRHH.',
      link: '/servicios/rrhh'
    },
    {
      icon: '🏥',
      title: 'Servicios Sociosanitarios',
      description: 'Atención especializada para centros de salud, clínicas y residencias con protocolos certificados.',
      link: '/servicios/sociosanitarios'
    },
    {
      icon: '✨',
      title: 'Soluciones Integrales',
      description: 'Servicios combinados y personalizados que integran múltiples áreas para soluciones completas.',
      link: '/servicios/soluciones-integrales'
    }
  ];

  return (
    <section className="services" id="servicios">
      <div className="section-title">
        <p className="section-subtitle">Nuestros Servicios</p>
        <h2>Soluciones Integrales Profesionales</h2>
      </div>
      <p className="section-description">
        Ofrecemos servicios especializados con productos ecológicos certificados, 
        garantizando la salud de su personal y el cuidado del medio ambiente.
      </p>
      
      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-icon">{service.icon}</div>
            <div className="service-content">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <Link to={service.link} className="service-link">
                Ver más detalles →
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
